import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/risk_assessment_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'RiskAssessment',
    column_type: 'string',
    column_name: 'name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'RiskAssessment',
      options: ['personal', 'company'],
    },
    model_name: 'RiskAssessment',
    column_name: 'kind',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'RiskAssessment',
      options: ['draft', 'published', 'closed'],
    },
    model_name: 'RiskAssessment',
    column_name: 'state',
  },
}
export const formColumnsConfig = {
  'self': {
    'kind': { required: true, disabledUpdate: false },
    'name': { required: true, disabledUpdate: false },
    'risk_assessment_questions': { required: false, disabledUpdate: false },
  },
  'risk_assessment_questions': {
    'id': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
    'position': { required: false, disabledUpdate: true },
    'content': { required: true, disabledUpdate: true },
    'kind': { required: true, disabledUpdate: false },
    'risk_assessment_options': { required: false, disabledUpdate: true },
  },
  'risk_assessment_questions.risk_assessment_options': {
    'id': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
    'content': { required: true, disabledUpdate: true },
    'score': { required: true, disabledUpdate: true },
    'position': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('RiskAssessment', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('RiskAssessment', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
